type CallEntry = {
  // Matches emergencyCallsSlice EmergencyCall.additionalData (unknown).
  additionalData?: unknown;
  core?: {
    locations?: { application?: string; source?: string }[];
  };
};

export type EmergencyCallsMap = Record<string, CallEntry>;

const additionalDataKeys = (additionalData: unknown): string[] => {
  if (!additionalData || typeof additionalData !== 'object') {
    return [];
  }
  return Object.keys(additionalData as Record<string, unknown>);
};

export const isCallerIDFromOrg = (
  org: string | null | undefined,
  emergencyCalls: EmergencyCallsMap | null | undefined,
  callerID: string | null | undefined,
): boolean => {
  if (!org || !emergencyCalls || !callerID) return false;

  const callerIDsFromOrg = Object.keys(emergencyCalls).filter(num => {
    const entry = emergencyCalls[num];
    return additionalDataKeys(entry?.additionalData).includes(org);
  });
  return callerIDsFromOrg.includes(callerID);
};
